import { z } from "zod";
import {
  isHttpUrlOrBlank,
  programUrlProblem,
  PROGRAM_URL_PROBLEM_MESSAGES,
} from "@/functions-shared/offer/programUrlValidation";

/**
 * KB-4351 — the admin forms' link fields. Blank is always allowed (every link is optional).
 *
 * - Program website: the program-page rules shared with the pipeline (`programUrlProblem`).
 * - Session website / Registration: http(s) only. Registration still runs `sanitizeAuthoredRegUrl`
 *   when the offer is saved; that refusal is a save-time drop, not a form error.
 */
export const programWebsiteSchema = z
  .string()
  .optional()
  .superRefine((value, ctx) => {
    const problem = programUrlProblem(value);
    if (problem) ctx.addIssue({ code: z.ZodIssueCode.custom, message: PROGRAM_URL_PROBLEM_MESSAGES[problem] });
  });

export const httpUrlOrBlankSchema = z
  .string()
  .optional()
  .refine(isHttpUrlOrBlank, { message: "Enter a full http(s) web address, or leave it blank" });
